// extracted by mini-css-extract-plugin
export default {"root":"MessageEntry-root","input":"MessageEntry-input","inputItem":"MessageEntry-inputItem","actions":"MessageEntry-actions"};